import script from "./AggregatedShowMore.vue?vue&type=script&setup=true&lang=js"
export * from "./AggregatedShowMore.vue?vue&type=script&setup=true&lang=js"

import "./AggregatedShowMore.vue?vue&type=style&index=0&id=e0d6809c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d6809c"]])

export default __exports__